import { BaseEvent } from "@/api/ws/events/BaseEvent";
import type { Comment } from "@/api/http/schemas/commentsSchema";

type CommentSavedForFileEventPayload = Comment & { is_shared_with_borrower: boolean };

export default class CommentSavedForFileEvent extends BaseEvent<CommentSavedForFileEventPayload> {
  name = ".comment_saved_for_file";
}
